export default __webpack_public_path__ + "static/media/arrow_up.bb25af92.svg";